import AGWeatherCard from "./AGWeatherCard";

export default AGWeatherCard;